<template>
  <slot v-if="showSlot" />
  <NTooltip v-else>
    <template #title>{{ $tl('unverify') }}</template>
    <span class="n-check-verify c-unverified" @click.capture="onClick">
      <slot />
    </span>
  </NTooltip>
</template>

<script setup>
import {computed} from 'vue';
import {useBootstrap} from '@front/hooks';

const { userProfile, verifyRequired } = useBootstrap();
const showSlot = computed(() => !verifyRequired.value || userProfile.value.verified);

function onClick(event) {
  event.stopImmediatePropagation();
  event.preventDefault();
}
</script>

<script>
export default {
  name: 'NCheckVerify',
};
</script>

<style lang="less">
.n-check-verify.c-unverified {
  background-color: white;
  opacity: 0.6;
}
</style>
